import React from "react";
import ReactDOM from "react-dom";

import { hostnameToStorefront } from "@glamcorner/core-cf-lib/lib/client";

export default class HerWardrobeMessage {
  constructor() {
    const root = document.querySelector("#her-wardrobe-message");
    if (root && hostnameToStorefront() === "herwardrobe") {
      import("./components/HerWardrobeMessage/HerWardrobeMessage").then((importedModule) => {
        const HerWardrobeMessage = importedModule.default;
        ReactDOM.render(<HerWardrobeMessage />, root);
      });
    }
  }
}
